<template>
  <div class="canceled-box">
    <div class="main-container">
      <h2 class="">キャンセル</h2>
      <div class="sort-box">
        <p>表示年：</p>
        <select class="" v-model="disp_year" @change="disp_chg()">
          <option v-for="(year, index) in years" :key="index" :value="year">{{year}}</option>
        </select>
      </div>
      <div class="sort-box">
        <p>ソート：</p>
        <select class="" @change="sort()" v-model="sort_flg">
          <option value="check_in1">チェックイン日(昇順)</option>
          <option value="check_in2">チェックイン日(降順)</option>
          <option value="check_out1">チェックアウト日(昇順)</option>
          <option value="check_out2">チェックアウト日(降順)</option>
          <option value="default">登録日</option>
        </select>
      </div>
      <div class="sort-box">
        <p>検索(代表者名)：</p>
        <input type="text" v-model="search_text">
      </div>

      <div class="list-box">
        <div class="list-header-box">
          <div class="flex">
            <p class="list-item5">部屋名</p>
            <p class="list-item2">代表者名</p>
            <p class="list-item6">人数/実</p>
            <p class="list-item4">ﾁｪｯｸｲﾝ日</p>
            <p class="list-item4">ﾁｪｯｸｱｳﾄ日</p>
            <p class="list-item3">代表者 email</p>
            <p class="list-item1">言語</p>
          </div>
        </div>

        <div class="list-contents-box">
          <div class="flex" v-for="(list, index) in lists" :key="index">
            <p class="list-item5">
              <span class="sub-title">部屋名</span>
              {{list.listing_name}}
            </p>
            <p class="list-item2">
              <span class="sub-title">代表者名</span>
              <a class="" @click="list_info(list)">{{list.name}}</a>
            </p>
            <p class="list-item6 center">
              <span class="sub-title">人数/実</span>
              {{list.customer_num}} / {{list.disp_customer_num}}
            </p>
            <p class="list-item4 center">
              <span class="sub-title">チェックイン日</span>
              {{list.check_in.substr(5)}}
            </p>
            <p class="list-item4 center">
              <span class="sub-title">チェックアウト日</span>
              {{list.check_out.substr(5)}}
            </p>
            <p class="list-item3">
              <span class="sub-title">代表者 email</span>
              {{list.email}}
            </p>
            <p class="list-item1 center">
              <span class="sub-title">言語</span>
              {{select_lang[list.language]}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const now_year = new Date().getFullYear();
export default {
  name: 'Canceled',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      select_lang: {'en': '英語', 'ja': '日本語'},
      sort_flg: 'default',
      disp_year: now_year,
      search_text: '',
      user_lists: [],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    years () {
      const year = new Date().getFullYear();
      return [year, year+1, year+2, year-1, year-2, year-3, year-4];
    },
    lists () {
      if (this.$lib._emptyChk(this.search_text) === false) {
        return this.user_lists;
      }
      const list = [];
      const num = this.user_lists.length;
      for (let i = 0; i < num; i++) {
        if (this.user_lists[i].name.indexOf(this.search_text) !== -1) {
          list.push(this.user_lists[i]);
        }
      }
      return list;
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.data_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('canceled_list_get.php');
    },
    data_get_cb (res) {
      this.user_lists = res.data.users;
      this.$store.commit('loginInfo/set_unaccepted_num', res.data.unaccepted_num);
      this.$store.commit('loginInfo/set_unregistered_num', res.data.unregistered_num);
    },
    list_info (list) {
      this.$router.push({name: 'list_info', params: {lodg_id: list.id, back: 'canceled'}});
    },
    disp_chg () {
      this.data_get();
    },
    sort () {
      let type;
      let flg;
      switch (this.sort_flg) {
      case 'check_in1': {
        type = 'check_in';
        flg = 'up';
        break;
      }
      case 'check_in2': {
        type = 'check_in';
        flg = 'down';
        break;
      }
      case 'check_out1': {
        type = 'check_out';
        flg = 'up';
        break;
      }
      case 'check_out2': {
        type = 'check_out';
        flg = 'down';
        break;
      }
      default: {
        type = 'updated_date';
        flg = 'down';
        break;
      }
      }
      if (flg === 'up') {
        this.lists.sort(function (a, b) {
          if (a[type] > b[type]) return 1;
          if (a[type] < b[type]) return -1;
          return 0;
        });
      } else {
        this.lists.sort(function (a, b) {
          if (a[type] > b[type]) return -1;
          if (a[type] < b[type]) return 1;
          return 0;
        });
      }
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.canceled-box {
  text-align: left;

  .main-container {
    .new-add {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      width: 100%;
      font-size: 16px;
      margin: 50px auto 20px auto;
      text-decoration: none;
      border-radius: 3px;
      width: 50%;
    }
    .list-box {
      overflow-y: auto;
      height: calc(100% - 230px);
      position: absolute;
      width: calc(100vw - 240px);
    }
    .list-header-box {
      position: sticky;
      top: 0;
      p {
        background: #fbfbfb;
        border-top: 1px solid #ceced2;
        border-left: 1px solid #ceced2;
        border-bottom: 1px solid #ceced2;
        padding: 8px 4px;
        color: #24273b;

        text-align: center;
        box-sizing: border-box;
        height: 40px;
        font-size: 0.9rem;
      }
      p:last-child {
        border-right: 1px solid #ceced2;
      }
    }
    .list-contents-box {
      p {
        background: #fbfbfb;
        border-bottom: 1px solid #ceced2;
        border-left: 1px solid #ceced2;
        padding: 10px 4px;

        box-sizing: border-box;
        word-break: break-all;
        display: flex;
        align-items: center;
        font-size: 0.8rem;
      }
      p:last-child {
        border-right: 1px solid #ceced2;
      }
      .sub-title {
        display: none;
      }
    }
    .list-item1 {
      min-width: 60px;
      max-width: 60px;
      justify-content: center;
    }
    .list-item2 {
      min-width: 150px;
      max-width: 150px;
      font-size: 1rem !important;
    }
    .list-item3 {
      min-width: 120px;
      flex: 1;
    }
    .list-item4 {
      min-width: 90px;
      max-width: 90px;
      justify-content: center;
      font-size: 1rem !important;
    }
    .list-item5 {
      min-width: 80px;
      max-width: 80px;
      font-size: 1rem !important;
      justify-content: center;
    }
    .list-item6 {
      min-width: 60px;
      max-width: 60px;
      justify-content: center;
    }
    .sort-box {
      display: flex;
      margin-bottom: 16px;
      p {
        width: 125px;
        padding-top: 6px;
        text-align: right;
        font-size: 14px;
      }
      select {
        height: 30px;
        font-size: 0.9rem;
      }
      input {
        width: 200px;
        height: 30px;
      }
    }
  }
  @media (max-width: 767px) {
    .main-container {
      .list-header-box {
        display: none;
      }
      .list-box {
        width: calc(100% - 20px);
      }
      .list-contents-box {
        p {
          border-right: 1px solid #ceced2;
          text-align: left;
        }
        p:first-child {
          border-top: 1px solid #ceced2;
        }
        .sub-title {
          font-size: 12px;
          display: block;
          width: 120px;
          color: #999999;
        }
        .flex {
          display: block;
          margin-bottom: 16px;
        }
        .list-item1 {
          min-width: inherit;
          max-width: inherit;
          justify-content: flex-start;
        }
        .list-item2 {
          min-width: inherit;
          max-width: inherit;
        }
        .list-item3 {
          min-width: inherit;
          flex: 1;
        }
        .list-item4 {
          min-width: inherit;
          max-width: inherit;
          justify-content: flex-start;
        }
        .list-item5 {
          min-width: inherit;
          max-width: inherit;
          justify-content: flex-start;
        }
        .list-item6 {
          min-width: inherit;
          max-width: inherit;
          justify-content: flex-start;
        }
      }
    }
  }
}
</style>
